var trackjs = {
	version: "1.0.0",
	vendor: "https://d2zah9y47r7bi2.cloudfront.net/releases/current/tracker.js"
};
var cdnUrls = {
	trackjs: trackjs
};

var trackjsSrc = cdnUrls.trackjs.vendor;

var WINDOW_KEY = '_trackJsErrorQueue';

if (!Array.isArray(window[WINDOW_KEY])) {
  window[WINDOW_KEY] = [];

  var origOnError = window.onerror || function () {};

  window.onerror = function (e) {
    window[WINDOW_KEY].push(e);

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    origOnError.apply(void 0, [e].concat(args));
  };
}

var errorQueue = (function () {
  return window[WINDOW_KEY];
});

var extractCreatives = (function (metadata) {
  if (!metadata) {
    return 'No ads metadata available.';
  }

  var ads = {};
  Object.keys(metadata).forEach(function (property) {
    if (metadata[property].adResponse && metadata[property].adResponse.ads) {
      var ad = metadata[property].adResponse.ads.slice().shift();
      ads[property] = ad.creative_id;
    }
  });
  return JSON.stringify(ads);
});

var ignoreRegExp = new RegExp(['appnexus', 'adform', 'adtech', 'adnxs\\.com', 'meetrics\\.net', 'demdex\\.net', 'revsci\\.net', '\\sawx\\w+\\s', 'mxcdn\\.net', 'adsafeprotected\\.com', 's3\\.amazonaws\\.com', 'serving-sys\\.com', 'atlassbx\\.com'].join('|'));
var defaultConfig = {
  token: '74bb3e28a1604fd2b28c72c568722d21',
  onError: function onError(payload, error) {
    if ((payload.message === "Can't execute code from a freed script" || payload.message === 'Script error.') && navigator.userAgent.indexOf('Edge') > -1) {
      return false;
    }

    if (error && error.stack && ignoreRegExp.test(error.stack.toString())) {
      return false;
    }

    payload.metadata.push({
      key: 'ads-metadata',
      value: extractCreatives(window.apntag && window.apntag.requests && window.apntag.requests.tags)
    });
    return true;
  },
  cookie: false,
  enabled: !window.location.host.includes('local')
};
var initiated = false;
var index = (function (data) {
  if (data === void 0) {
    data = {};
  }

  if (initiated) {
    return;
  }

  function sendError(e) {
    window.trackJs.console.info('From async loading queue');
    window.trackJs.track(e);
  }

  var options = Object.assign({}, defaultConfig, {}, window._trackJs, {}, data);

  if (typeof options.application !== 'string') {
    throw new Error("Expected application name as a string, received " + options.application);
  }

  window._trackJs = options;
  var s = document.createElement('script');
  s.src = trackjsSrc;
  s.crossorigin = '';

  s.onload = function sendQueuedErrors() {
    errorQueue().forEach(sendError);
  };

  document.body.appendChild(s);
  initiated = true;
});

export default index;
